import axiosInstance from "./config";

export const getAllLeavesApi = async () => {
  const res = await axiosInstance.get("/leave/all");
  return res.data;
};

export const approveLeaveApi = async (id) => {
  const res = await axiosInstance.put(`/leave/update/${id}`, {
    status: "Approved",
  });

  return res.data;
};

export const rejectLeaveApi = async (id) => {
  const res = await axiosInstance.put(`/leave/update/${id}`, {
    status: "Rejected",
  });

  return res.data;
};